<template>
  <div class="media">
    <div class="media__container" v-if="isSupportedFile">
      <img v-if="isSupportedImage" :src="file.url" :alt="file.title" class="img" />
      <audio v-else-if="isSupportedAudio" controls class="audio" autoplay>
        <source :src="file.url" />
      </audio>
      <video v-else-if="isSupportedVideo" controls class="video" autoplay>
        <source :src="file.url" />
      </video>
    </div>
    <div class="media__icon" v-else>
      <component :is="iconComponent"></component>
    </div>
    <p class="media__title" v-if="file">{{ file.title }}</p>
  </div>
</template>

<script>
  import { File } from '../services/FileService';

  import IconDoc from './icons/icon-doc.vue';
  import IconDocx from './icons/icon-docx.vue';
  import IconAvi from './icons/icon-avi.vue';
  import IconApk from './icons/icon-apk.vue';
  import IconBmp from './icons/icon-bmp.vue';
  import IconGif from './icons/icon-gif.vue';
  import IconHtml from './icons/icon-html.vue';
  import IconJpeg from './icons/icon-jpeg.vue';
  import IconJpg from './icons/icon-jpg.vue';
  import IconMp3 from './icons/icon-mp3.vue';
  import IconMp4 from './icons/icon-mp4.vue';
  import IconMpg from './icons/icon-mpg.vue';
  import IconPdf from './icons/icon-pdf.vue';
  import IconPng from './icons/icon-png.vue';
  import IconPptx from './icons/icon-pptx.vue';
  import IconRar from './icons/icon-rar.vue';
  import IconRaw from './icons/icon-raw.vue';
  import IconTif from './icons/icon-tif.vue';
  import IconTxt from './icons/icon-txt.vue';
  import IconXls from './icons/icon-xls.vue';
  import IconZip from './icons/icon-zip.vue';
  import IconAnon from './icons/icon-anon.vue';
  import IconUnclear from './icons/icon-unclear.vue';
  import IconDanger from './icons/icon-danger.vue';

  export default {
    name: 'Media',
    components: {
      'icon-doc': IconDoc,
      'icon-docx': IconDocx,
      'icon-apk': IconApk,
      'icon-avi': IconAvi,
      'icon-bmp': IconBmp,
      'icon-gif': IconGif,
      'icon-html': IconHtml,
      'icon-jpeg': IconJpeg,
      'icon-jpg': IconJpg,
      'icon-mp3': IconMp3,
      'icon-mp4': IconMp4,
      'icon-mpg': IconMpg,
      'icon-pdf': IconPdf,
      'icon-png': IconPng,
      'icon-pptx': IconPptx,
      'icon-rar': IconRar,
      'icon-raw': IconRaw,
      'icon-tif': IconTif,
      'icon-tiff': IconTif,
      'icon-txt': IconTxt,
      'icon-xls': IconXls,
      'icon-zip': IconZip,
      'icon-anon': IconAnon,
      'icon-unclear': IconUnclear,
      'icon-danger': IconDanger
    },
    props: {
      file: File
    },
    computed: {
      iconComponent() {
        if (!this.file) {
          return null;
        }

        const component = `icon-${this.file.extension.toLowerCase()}`;

        if (this.file.isTypeCorrespondsToExtension) {
          if (component in this.$options.components) {
            return component;
          } else {
            return 'icon-anon';
          }
        } else {
          return 'icon-danger';
        }
      },

      isSupportedFile() {
        return this.file?.isSupportedFile;
      },

      isSupportedAudio() {
        return this.file?.isSupportedAudio;
      },

      isSupportedVideo() {
        return this.file?.isSupportedVideo;
      },

      isSupportedImage() {
        return this.file?.isSupportedImage;
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import 'src/scss/variables';

  .media {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 20px 0;

    &__icon {
      width: 251px;
      height: 229px;
      border-radius: 17px;
      background: rgba($light-blue-2, 0.04);
      color: $light-blue-4;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__title {
      margin-top: 32px;
      word-break: break-all;
      padding: 0 20px;
      line-height: 1.5;
    }

    .img,
    .video {
      border-radius: 17px;
      box-shadow: 0 6px 32px 0 rgba($dark-blue, 0.11);
    }

    .video,
    .audio {
      width: 251px;
      max-height: 229px;

      &:focus {
        outline: none;
      }
    }

    .img {
      max-width: 251px;
      max-height: 229px;
    }
  }
</style>
